import { useEffect } from "react";

/* Centered modal with backdrop */
const FullScreenImg = ({ imgSrc, onClose }) => {
  // Close with ESC key
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="confirm-overlay" style={{marginTop: "12vh"}} role="presentation" onClick={onClose}>
      {/* stop propagation so clicks inside the card don't close */}
      <div
        className="confirm-card"
        role="dialog"
        aria-modal="true"
        style={{
          width: "100vw",
          height: "100vh",
          maxWidth: "100vw",
          maxheight: "100vh",
          backgroundColor: "rgb(237, 71, 9)",
          outline: "none",
          border: "none",
          color: "white",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imgSrc}
          style={{
            width: "100%",
            height: "calc(100% - 60px)",
            objectFit: "contain",
          }}
          alt="Stencil"
        />

        <div className="confirm-actions mt-2">
          <button
            className="btn confirm-no"
            style={{
              outline: "none",
              border: "none",
              color: "white",
              backgroundColor: "darkgreen",
            }}
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FullScreenImg;
